import { render } from "./MainSideBar.vue?vue&type=template&id=2930b7ef&scoped=true"
import script from "./MainSideBar.vue?vue&type=script&lang=js"
export * from "./MainSideBar.vue?vue&type=script&lang=js"

import "./MainSideBar.vue?vue&type=style&index=0&id=2930b7ef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2930b7ef"]])

export default __exports__